import queryClient from "../../../service/reactQuery/queryClient";
import { useFetchPlansAll } from "../Service/query";
import { CreatePlanRequest, DeletePlansRequest, EditPlansRequest } from "../Service/request";
import { useMutation } from 'react-query'

// import { EditUserRequest, SignUpRequest } from "../Services/request";


const PlansState = () => {

    const { data: plans, isLoading } = useFetchPlansAll()

    const EditPlansMutation = useMutation(
        ({body, close}) => EditPlansRequest(body),
        {
            onMutate: () => {
            },
            onError: (error) => {

            },
            onSuccess: (result, veriables, context) => {
                queryClient.refetchQueries("UsePlansAll")
                veriables.close()
            },
        }
    );

    const DeletePlansMutation = useMutation(
        (id) => DeletePlansRequest(id),
        {
            onMutate: () => {
            },
            onError: (error) => {

            },
            onSuccess: (result, veriables, context) => {
                queryClient.refetchQueries("UsePlansAll")
            },
        }
    );

    const CreatePlanMutation = useMutation(({data, close}) => CreatePlanRequest(data), {
        onMutate: () => {
        },
        onError: (error) => {
        },
        onSuccess: (result, variables, context) => {
            queryClient.refetchQueries("UsePlansAll")
            variables.close()
        },
    });

    const CreatePlan = (body, close) => {
        CreatePlanMutation.mutate({data: body, close: close})
    }

    const EditPlans = (body, close) => {
        EditPlansMutation.mutate({body: body, close: close})
    }

    const DeletePlans = (id) => {
        console.log(id)
        DeletePlansMutation.mutate(id)
    }

    return {
        plans, isLoading, EditPlans, CreatePlan, DeletePlans
    }
}

export default PlansState